import React, { useEffect, useRef } from 'react';
import mapIcon from '../assets/icons/marker.png';

const GOOGLE_MAPS_API_KEY = 'AIzaSyDuuiA3McOlGYqEwHaK7FqTFv4jksBuUtM';

function CustomMap({ data = [], center, zoom }) {
  const mapRef = useRef(null);
  const initializeMap = () => {
    if (mapRef.current && window.google) {
      const map = new window.google.maps.Map(mapRef.current, {
        center,
        zoom,
        styles: [],
        disableDefaultUI: true,
        zoomControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
      });

      data.forEach((item) => {
        // eslint-disable-next-line no-new
        new window.google.maps.Marker({
          position: { lat: +item.latitude, lng: +item.longitude },
          map,
          icon: {
            url: mapIcon,
            scaledSize: new window.google.maps.Size(80, 80),
          },
          title: item.name,
        });
      });
    }
  };
  useEffect(() => {
    const loadGoogleMapsScript = () => {
      const existingScript = document.getElementById('google-maps-script');
      if (!existingScript) {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}`;
        script.id = 'google-maps-script';
        script.async = true;
        script.defer = true;
        script.onload = initializeMap;
        document.body.appendChild(script);
      } else {
        initializeMap();
      }
    };

    loadGoogleMapsScript();
  }, [data, center, zoom]);

  return (
    <div
      ref={mapRef}
      style={{
        width: '100%',
        height: '100%',
        borderRadius: '24px',
        overflow: 'hidden',
      }}
    />
  );
}

export default CustomMap;
